/* ============================================================
   Igloo Startbonus-Rechner – ALTE Logik (250€ Gutschein ab
   3 Testboxen). Nur aktiv bis zum im Theme-Editor hinterlegten
   Stichtag (serverseitig per Liquid geprueft, siehe Section).
   ============================================================ */
(function(){
  const root = document.getElementById('gcb-starterkit-root');
  if(!root) return;

  const DATA = window.gcStartbonusData;
  const VOUCHER_THRESHOLD = parseInt(root.dataset.voucherThreshold, 10) || 3;
  const VOUCHER_AMOUNT = parseFloat(root.dataset.voucherAmount) || 250;

  let selectedDevice = 'dc';
  let selectedPos = 'fenster30';
  let quantities = {};
  DATA.tests.forEach(t => quantities[t.key] = 0);
  quantities['lancet'] = 0;
  let lancetManuallySet = false;

  function fmt(n){
    return Number(n).toLocaleString('de-DE', {minimumFractionDigits:2, maximumFractionDigits:2}) + ' €';
  }
  function currentDevice(){ return DATA.device[selectedDevice]; }

  function buildRows(){
    const container = document.getElementById('gcb-test-rows');
    container.innerHTML = '';
    DATA.tests.forEach(t => {
      const row = document.createElement('div');
      row.className = 'cfg-row';
      row.id = 'gcb-row-' + t.key;
      const infoIcon = '<svg class="cfg-link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 11v5" stroke-linecap="round"/><circle cx="12" cy="8" r="0.6" fill="currentColor" stroke="none"/></svg>';
      const infoLink = t.url
        ? `<a class="cfg-link cfg-link-preview" href="${t.url}" data-test-key="${t.key}">${infoIcon}Informationen</a>`
        : '';
      row.innerHTML = `
        <div class="cfg-info">
          <div class="cfg-label-row">
            <span class="cfg-label">${t.label}</span>
            ${infoLink}
          </div>
          <div class="cfg-meta">${t.perBox} Stk./Box</div>
        </div>
        <div class="cfg-right">
          <span class="cfg-total zero" id="gcb-total-${t.key}">${fmt(t.price)}</span>
          <div class="qty-ctrl">
            <button class="qty-btn" data-key="${t.key}" data-delta="-1" type="button">−</button>
            <span class="qty-num" id="gcb-qty-${t.key}">0</span>
            <button class="qty-btn" data-key="${t.key}" data-delta="1" type="button">+</button>
          </div>
        </div>`;
      container.appendChild(row);
    });
    container.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => adj(btn.dataset.key, parseInt(btn.dataset.delta, 10)));
    });
    container.querySelectorAll('.cfg-link-preview').forEach(link => {
      const t = DATA.tests.find(x => x.key === link.dataset.testKey);
      if(!t) return;
      link.addEventListener('mouseenter', (e) => gcRenderPreview(e, {
        title: t.label,
        price: '€ ' + Number(t.price).toLocaleString('de-DE', {minimumFractionDigits:2}),
        desc: t.desc || '',
        image: t.image || ''
      }));
      link.addEventListener('mouseleave', () => gcHidePreview());
    });
  }

  function adj(key, delta){
    quantities[key] = Math.max(0, quantities[key] + delta);
    document.getElementById('gcb-qty-' + key).textContent = quantities[key];
    const t = DATA.tests.find(x => x.key === key);
    const totalEl = document.getElementById('gcb-total-' + key);
    const qty = quantities[key];
    if(qty > 0){
      totalEl.textContent = fmt(t.price * qty);
      totalEl.classList.remove('zero');
    } else {
      totalEl.textContent = fmt(t.price);
      totalEl.classList.add('zero');
    }
    autoSuggestLancets();
    updateAll();
  }

  window.switchDeviceBonus = function(device){
    selectedDevice = device;
    const isPro = device === 'pro';
    document.getElementById('gcb-device-label').textContent = isPro
      ? (DATA.device.pro.title + ' (Vorgängermodell)')
      : DATA.device.dc.title;
    document.getElementById('gcb-device-price').textContent = fmt(currentDevice().price);

    const detailLink = document.getElementById('gcb-device-detail-link');
    if(detailLink){
      detailLink.href = currentDevice().url;
      detailLink.onmouseenter = function(e){
        gcRenderPreview(e, {
          title: currentDevice().title,
          price: '€ ' + currentDevice().price.toLocaleString('de-DE', {minimumFractionDigits:2}),
          desc: currentDevice().desc || '',
          image: currentDevice().image || ''
        });
      };
      detailLink.onmouseleave = () => gcHidePreview();
    }

    const toggle = document.getElementById('gcb-device-toggle');
    if(toggle){
      toggle.innerHTML = isPro
        ? `Sie möchten doch den <a class="cfg-link" onclick="switchDeviceBonus('dc')">${DATA.device.dc.title}</a> wählen?`
        : `Interesse am Vorgängermodell? <a class="cfg-link" onclick="switchDeviceBonus('pro')">${DATA.device.pro.title} wählen</a>`;
    }
    document.getElementById('gcb-device-note').classList.toggle('show', isPro);

    DATA.tests.forEach(t => {
      if(t.isLipidPanel){
        const row = document.getElementById('gcb-row-' + t.key);
        if(row) row.style.display = isPro ? 'none' : '';
        if(isPro && quantities[t.key] > 0){
          quantities[t.key] = 0;
          document.getElementById('gcb-qty-' + t.key).textContent = 0;
          const totalEl = document.getElementById('gcb-total-' + t.key);
          totalEl.textContent = fmt(t.price);
          totalEl.classList.add('zero');
        }
      }
    });

    autoSuggestLancets();
    updateAll();
  };

  function totalTestUnits(){
    return DATA.tests.reduce((s,t) => t.lancetsIncluded ? s : s + t.perBox * quantities[t.key], 0);
  }
  function requiredLancetBoxes(){
    const total = totalTestUnits();
    return total === 0 ? 0 : Math.ceil(total / DATA.lancet.perBox);
  }
  function autoSuggestLancets(){
    if(!lancetManuallySet) quantities['lancet'] = requiredLancetBoxes();
    refreshLancetDisplay();
  }
  function refreshLancetDisplay(){
    const qty = quantities['lancet'];
    document.getElementById('gcb-qty-lancet').textContent = qty;
    const totalEl = document.getElementById('gcb-total-lancet');
    if(qty > 0){
      totalEl.textContent = fmt(DATA.lancet.price * qty);
      totalEl.classList.remove('zero');
    } else {
      totalEl.textContent = fmt(DATA.lancet.price);
      totalEl.classList.add('zero');
    }
    document.getElementById('gcb-lancet-meta').textContent = (qty * DATA.lancet.perBox) + ' Stk. gesamt';
    document.getElementById('gcb-lancet-warning').classList.toggle('show', (qty * DATA.lancet.perBox) < totalTestUnits());
  }
  function adjLancet(delta){
    lancetManuallySet = true;
    quantities['lancet'] = Math.max(0, quantities['lancet'] + delta);
    refreshLancetDisplay();
    updateAll();
  }

  function discountQty(){
    return DATA.tests.reduce((s,t) => s + quantities[t.key], 0);
  }

  function updateAll(){
    const testsSubtotal = DATA.tests.reduce((s,t) => s + t.price * quantities[t.key], 0);
    const lancetSubtotal = DATA.lancet.price * quantities['lancet'];
    const total = currentDevice().price + testsSubtotal + lancetSubtotal;
    document.getElementById('gcb-grand-total').textContent = fmt(total);

    const dq = discountQty();
    const block = document.getElementById('gcb-voucher-block');
    const title = document.getElementById('gcb-voucher-title');
    const sub   = document.getElementById('gcb-voucher-sub');
    const amt   = document.getElementById('gcb-voucher-amount');
    const fill  = document.getElementById('gcb-progress-fill');
    fill.style.width = Math.min(100, (dq / VOUCHER_THRESHOLD) * 100) + '%';
    amt.textContent = fmt(VOUCHER_AMOUNT);

    if(dq >= VOUCHER_THRESHOLD){
      block.className = 'voucher-block active';
      title.textContent = '🎁 Gutschein freigeschaltet';
      sub.innerHTML = 'Sie haben ' + dq + ' Testboxen gewählt. Nach Abschluss Ihrer Bestellung erhalten Sie einen Gutscheincode für Ihre <strong>nächste</strong> Bestellung.';
    } else {
      block.className = 'voucher-block pending';
      const lack = VOUCHER_THRESHOLD - dq;
      title.textContent = dq + ' / ' + VOUCHER_THRESHOLD + ' Testboxen';
      sub.textContent = lack + (lack === 1 ? ' Testbox fehlt' : ' Testboxen fehlen') + ' bis zum Gutschein für Ihre nächste Bestellung.';
    }
  }

  async function orderStartbonus(){
    const btn = document.getElementById('gcb-order-btn');
    const items = [{ id: currentDevice().variantId, quantity: 1 }];
    DATA.tests.forEach(t => { if(quantities[t.key] > 0) items.push({ id: t.variantId, quantity: quantities[t.key] }); });
    if(quantities['lancet'] > 0) items.push({ id: DATA.lancet.variantId, quantity: quantities['lancet'] });

    const posFreeEligible = discountQty() >= VOUCHER_THRESHOLD;
    if(selectedPos === 'fenster30' && DATA.pos.basis.regularVariantId){
      const posId = posFreeEligible ? DATA.pos.basis.freeVariantId : DATA.pos.basis.regularVariantId;
      if(posId) items.push({ id: posId, quantity: 1 });
    } else if(selectedPos === 'ninaruge170' && DATA.pos.premium.regularVariantId){
      const posId = posFreeEligible ? DATA.pos.premium.freeVariantId : DATA.pos.premium.regularVariantId;
      if(posId) items.push({ id: posId, quantity: 1 });
    }

    if(items.some(i => !i.id)){
      alert('Es sind noch nicht alle Produkte im Theme-Editor mit echten Shopify-Produkten verknüpft.');
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt …';
    const result = await gcAddItemsToCart(items, { startbonus_flow: 'true' });
    btn.disabled = false;
    btn.textContent = 'In den Warenkorb legen';
    if(result) window.location.href = window.Shopify.routes.root + 'cart';
  }
document.querySelectorAll('.pos-option[data-pos-title]').forEach(label => {
  label.addEventListener('mouseenter', (e) => gcRenderPreview(e, {
    title: label.dataset.posTitle,
    price: '',
    desc: label.dataset.posDesc || '',
    image: label.dataset.posImage || '',
    size: 'large'
  }));
  label.addEventListener('mouseleave', () => gcHidePreview());
});

  document.querySelectorAll('input[name="gcb-pos"]').forEach(radio => {
    radio.addEventListener('change', () => { selectedPos = radio.value; });
  });

  buildRows();
  switchDeviceBonus('dc');
  autoSuggestLancets();
  updateAll();
  document.getElementById('gcb-lancet-minus').addEventListener('click', () => adjLancet(-1));
  document.getElementById('gcb-lancet-plus').addEventListener('click', () => adjLancet(1));
  document.getElementById('gcb-order-btn').addEventListener('click', orderStartbonus);
})();